import { Controller, Get, UseGuards } from '@nestjs/common';
import { AuthGuard } from '@nestjs/passport';
import { ApiBearerAuth, ApiTags } from '@nestjs/swagger';
import { GetUser } from 'src/auth/get-user.decorator';
import { ModulosService } from './modulos.service';

@ApiTags('Modulos')
@ApiBearerAuth()
@UseGuards(AuthGuard('jwt'))
@Controller({ path: 'modulos', version: '1' })
export class ModulosController {
  constructor(private readonly modulosService: ModulosService) {}

  @Get()
  findAll(@GetUser() user: any) {
    return this.modulosService.findAllForEmpresa(user.empresa_id);
  }
}
